import React, { useCallback } from "react"
import { createStyles, forwardRef, HTMLStyledProps } from "@design-system/core"
import { __DEV__ } from "@design-system/utils"
import { useModalContext } from "./ModalContext"

import { CloseButton, CloseButtonProps } from "@design-system/close-button"

const styles = createStyles((theme) => ({
  root: {
    position: "absolute",
    right: theme.spaces.spacing32,
    top: theme.spaces.spacing32,
  },
  widthSmall: {
    right: theme.spaces.spacing16,
    top: theme.spaces.spacing16,
    width: theme.spaces.spacing24,
    height: theme.spaces.spacing24,
  },
}))

export const ModalCloseButton = forwardRef<CloseButtonProps, "div">(
  (props, ref) => {
    const { style, ...others } = props
    const { onClose, widthSmall } = useModalContext()

    const handleClick = useCallback(
      (e: React.MouseEvent) => {
        e.stopPropagation()
        onClose?.()
      },
      [onClose],
    )

    return <CloseButton
      {...others}
      platform="mobile"
      ref={ref}
      style={[styles.root, widthSmall && styles.widthSmall, style]}
      onClick={handleClick}
      />
  },
)

if (__DEV__) {
  ModalCloseButton.displayName = "ModalCloseButton"
}
